/* eslint-env browser, jquery */

'use strict';

const ProductBundles =
  window.ProductBundles != null
    ? window.ProductBundles
    : (window.ProductBundles = {});

if (ProductBundles.Views == null) {
  ProductBundles.Views = {};
}

ProductBundles.Views.Bundle = require('./product_bundle');

ProductBundles.Views.Bundles = window.Backbone.View.extend({
  el: '#product-bundles',
  initialize(productBundlesObj) {
    const {
      productBundles,
      optionsBundlesMap,
      bundlesTitle,
      preselectedOption,
      isTouch,
    } = productBundlesObj;
    this.productBundles = productBundles;
    this.optionsBundlesMap = optionsBundlesMap;
    this.bundlesTitle = bundlesTitle;
    this.preselectedOption = preselectedOption;
    this.$bundleItemsElem = this.$el.find('.product-bundles-items');
    this.isTouch = isTouch;
    this.$el.hide();
    this.onGoodsOptionUpdate = this.onGoodsOptionUpdate.bind(this);
    window.DealEventPipe.on('goodsOptionUpdate', this.onGoodsOptionUpdate);
    this.setCurrentSelectedOption();
    this.initializeBundleViews();
    return this.render();
  },
  initializeBundleViews() {
    if (this.bundleViews && this.bundleViews.length) {
      // clean up old views
      this.bundleViews.forEach(bundleView => bundleView.remove());
    }
    this.bundleViews = [];
    const bundles = this.getSelectedOptionBundles();
    bundles.forEach(bundle =>
      this.bundleViews.push(this.createBundleView(bundle))
    );
  },
  onGoodsOptionUpdate(data) {
    this.updateOptionInfo(data);
    this.initializeBundleViews();
    this.render();
  },
  updateOptionInfo({ deal, uuid }) {
    return (this.optionInfo = {
      dealUuid: deal,
      uuid,
    });
  },
  setCurrentSelectedOption() {
    const $selectedOption = $('.m-option-b input[type=radio]:checked');
    let selectedOption = {};

    if ($selectedOption.length) {
      selectedOption = $selectedOption.data();
    } else if (this.preselectedOption) {
      selectedOption = this.preselectedOption;
    }
    return this.updateOptionInfo(selectedOption);
  },
  getSelectedOptionBundles() {
    if (!this.optionInfo.uuid) {
      return [];
    }
    const optionUuid = this.optionInfo.uuid;
    const bundles = [];
    if (this.optionsBundlesMap[optionUuid]) {
      this.optionsBundlesMap[optionUuid].map(
        (function(_this) {
          return function(bundleUuid) {
            return bundles.push(_this.productBundles[bundleUuid]);
          };
        })(this)
      );
    }
    return bundles;
  },
  createBundleView(bundle) {
    const model = new window.Backbone.Model({
      isSelected: false,
      uuid: bundle.uuid,
    });
    const bundleView = new ProductBundles.Views.Bundle({
      model,
      bundle,
      bundlesTitle: this.bundlesTitle,
      isTouch: this.isTouch,
    });
    bundleView.on('update-item-in-cart', this.updateItemInCart.bind(this));
    return bundleView;
  },
  updateItemInCart(item) {
    if (item.shouldRemove) {
      window.DealEventPipe.trigger('cartFormRemoveItem', item);
    } else {
      window.DealEventPipe.trigger('cartFormAddItem', item);
    }
  },
  renderBundle(bundleView) {
    bundleView.render();
    return this.$bundleItemsElem.append(bundleView.el);
  },
  render() {
    this.$el.hide();
    this.$bundleItemsElem.empty();
    if (this.bundleViews.length) {
      this.bundleViews.forEach(bundleView => {
        bundleView.render();
        this.$bundleItemsElem.append(bundleView.el);
      });
      this.$el.show();
    }
  },
});

module.exports = ProductBundles.Views.Bundles;
